import React from 'react'
import Kpirepairviewfile from '../../components/kpirepairreportcomponent/Kpirepairviewfile'


function  Kpirepairview({renderPageContent}) {
    return (
        <>
                        <Kpirepairviewfile renderPageContent={renderPageContent}/>
        </>
    )
}

export default  Kpirepairview